// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---cache-caches-gatsby-plugin-offline-app-shell-js": () => import("./../../caches/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---cache-caches-gatsby-plugin-offline-app-shell-js" */),
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-page-1-tsx": () => import("./../../../src/pages/page1.tsx" /* webpackChunkName: "component---src-pages-page-1-tsx" */),
  "component---src-pages-page-2-index-tsx": () => import("./../../../src/pages/page2/index.tsx" /* webpackChunkName: "component---src-pages-page-2-index-tsx" */),
  "component---src-pages-page-2-page-3-tsx": () => import("./../../../src/pages/page2/page3.tsx" /* webpackChunkName: "component---src-pages-page-2-page-3-tsx" */)
}

